// extracted by mini-css-extract-plugin
export default {"container":"FormStep_container__wAHh9","checkbox":"FormStep_checkbox__KJv-5","checkboxLabel":"FormStep_checkboxLabel__w9sWx"};